import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import sample1 from '../images/dynasample3.svg';
import sample2 from '../images/dynasample2.svg';
import sample3 from '../images/dynasample1.svg';
import sample4 from '../images/dynasample9.svg';
import sample5 from '../images/dynasample4.svg';
import sample6 from '../images/dynasample6.svg';

import {
  Link
} from "react-router-dom";

import { generateRandomStripesDataUri } from '../utils/DynaStripes.js';
import SocialLinks from '../components/SocialLinks';
import DynaSpan from '../components/DynaSpan';

const HomePage = () => {
  const [, setTick] = useState(0);

  const update = () => {
    console.log("Updating Stripes..");
    setTick(t => t + 1);
  }

  const svgDataUri = generateRandomStripesDataUri();

  return (
    <div className="mainContent" style={{ background: svgDataUri }} onClick={update}>
      <div className="content">

        <h1 className="homeTitle">
          <DynaSpan />: <b>user-directed</b>, generative, on-chain NFT art
        </h1>
        <div className="homeAbout">
          <div className="samples">
            <img className="sample" alt="sample dyna stripes 1" src={sample1} />
            <img className="sample" alt="sample dyna stripes 2" src={sample2} />
            <img className="sample" alt="sample dyna stripes 3" src={sample3} />
            <img className="sample" alt="sample dyna stripes 4" src={sample4} />
            <img className="sample" alt="sample dyna stripes 5" src={sample5} />
            <img className="sample" alt="sample dyna stripes 6" src={sample6} />
          </div>
          <div className="featureList">
            <ul>
              <li>
                <b>User-directed:</b> you select the input parameters!
              </li>
              <li>
                <b>Generative:</b> art created by a smart contract algorithm
              </li>
              <li>
                <b>On-chain:</b> including both artwork & metadata
              </li>
              <li>
                <b>Royalties:</b> 100% assigned to you!
              </li>
            </ul>
          </div>
          <div className="mid20th">
            Channel your inner Donald Judd or Josef Albers and create a minimalist, mid-20th century masterpiece! Free mint, only pay gas. 😎
          </div>
          <div className="actions">
            <Link to="/mint">
              <Button variant="primary">Create an Artwork!</Button>
            </Link>
            <Link to="/gallery">
              <Button variant="primary">Browse recent NFTs</Button>
            </Link>
          </div>
        </div>
        <br />
        <SocialLinks />
      </div>
    </div>
  );
}

export default HomePage;